import { useQuery } from 'react-query';
import { axiosInstance } from '../services/apiClient';

export interface VectorTypeOption {
  value: string;
  label: string;
}

const VECTOR_TYPE_OPTIONS_QUERY_KEY = 'vectorTypeOptions';

async function fetchVectorTypeOptions(): Promise<VectorTypeOption[]> {
  const { data } = await axiosInstance.get<VectorTypeOption[]>(
    '/energy-vectors/vector-type-options'
  );
  return data;
}

export const useVectorTypeOptions = () => {
  return useQuery<VectorTypeOption[]>(VECTOR_TYPE_OPTIONS_QUERY_KEY, fetchVectorTypeOptions);
};
